import type { RejectionGroundTextDto } from "../../autogen/bff-api";
import { isApiErrorDto } from "../errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../errors/isFetchBaseQueryError";

const GROUND_TEXT_FIELD = /(?:^|\.)groundTexts\.(\d+)\.text$/;
const REASON_FIELD = /^(?:reason|rejectionReason)$/;

const fieldErrorsOf = (error: unknown) => {
  const body = isFetchBaseQueryError(error) ? error.data : error;
  return isApiErrorDto(body) ? body.fieldErrors ?? [] : [];
};

export const refusesReason = (error: unknown): boolean =>
  fieldErrorsOf(error).some((fieldError) => REASON_FIELD.test(fieldError.field));

export const refusedGroundKeys = (error: unknown, groundTexts: RejectionGroundTextDto[]): string[] =>
  fieldErrorsOf(error).flatMap((fieldError) => {
    const index = GROUND_TEXT_FIELD.exec(fieldError.field)?.[1];
    const key = index === undefined ? undefined : groundTexts[Number(index)]?.key;
    return key ? [key] : [];
  });
